import { useState } from "react";
import { Input } from "@/components/ui/Input";

interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const formatPhoneNumber = (value: string): string => {
  const phoneNumber = value.replace(/\D/g, "");
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const toE164 = (value: string): string => {
  const digits = value.replace(/\D/g, "");
  return digits.length === 10 ? `+1${digits}` : "";
};

export const PhoneInput = ({ onChange, error }: PhoneInputProps) => {
  const [displayValue, setDisplayValue] = useState("");
  const [validationError, setValidationError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const formatted = formatPhoneNumber(input);
    setDisplayValue(formatted);

    const e164 = toE164(input);
    if (e164) {
      setValidationError("");
      onChange(e164);
    } else if (input.replace(/\D/g, "").length >= 10) {
      setValidationError("Invalid phone number");
    }
  };

  return (
    <Input
      type="tel"
      label="Phone Number"
      value={displayValue}
      onChange={handleChange}
      error={error || validationError}
      placeholder="(555) 123-4567"
      maxLength={14}
    />
  );
};
